import React from 'react';
import styles from './LocationsPins.module.scss';

const LocationsPins = ({ list, type = 'circle' }) => {
  return ( 
    <ul className={ styles.LocationsPins }>
      { list && list.map((location, i) =>
        <li key={ location }>
          <span className={ `${styles.marker} ${styles[type]}` }>
            { type === 'circle' && '⬤' }
            { type === 'numeric' && i + 1 }
          </span>
          <span className={ styles.label }>{ location }</span>
        </li>
      )
      }
    </ul>
  );
};
 
export default LocationsPins;